export default __webpack_public_path__ + "static/media/AMH_White.e2abc2fc.png";